import { render } from "./WineIcon.vue?vue&type=template&id=214db7a0"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/WineIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "214db7a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('214db7a0', __exports__)) {
    api.reload('214db7a0', __exports__)
  }
  
  module.hot.accept("./WineIcon.vue?vue&type=template&id=214db7a0", () => {
    api.rerender('214db7a0', render)
  })

}


export default __exports__